import find from 'lodash-es/find'
import isFunction from 'lodash-es/isFunction'

import { isEmpty } from '/@/utils/is'

/**
 * @method findInNested
 * @param ref {Recordable[]|Recordable} Holds reference object.
 * @param predicate Holds finding value.
 * @description Applies recursion while finding value in nested object.
 * @returns undefined|Recordable
 */
export function findInNested(ref: Recordable, predicate: string): Recordable | undefined {
  return find(ref, (value, key) => {
    const result = key === predicate
    if (!result) return findInNested(value, predicate)
    return result
  })
}

/**
 * @method filterArrayWithShow
 * @description Filters an array of objects based on their 'show' property.
 * @param items {any[]} - The array of objects to filter.
 * @returns The filtered array containing only objects that should be shown.
 * @example
 * const items = [
 *   { id: 1, name: 'Item 1', show: true },
 *   { id: 2, name: 'Item 2', show: false },
 *   { id: 3, name: 'Item 3', show: () => true }
 * ];
 * const filteredItems = filterArrayWithShow(items);
 * // filteredItems => [{ id: 1, name: 'Item 1', show: true }, { id: 3, name: 'Item 3', show: () => true }]
 */
export function filterArrayWithShow(items: any[]) {
  return items.filter((item: any) => {
    if (isFunction(item.show)) return item.show(item)
    if (isEmpty(item.show)) return true
    return item.show
  })
}
